export default __webpack_public_path__ + "7ba26446a80ddd9e30901c9aeda2b714.png";